<motif-form-field *ngIf="!shareUser" class="searchField">
  <label motifLabel *ngIf="inlineLabel" [for]="searchInputId" [ngClass]="ShowValidationStar ? 'required' : ''">{{ inlineLabel }}</label>
  <input #searchInput [id]="searchInputId" class="searchInput" type="text" motifInput aria-label="State" [labelPosition]="labelPosition"
    placeholder="{{'SearchUser' | translate}}" (keyup)="onInputChange($event)" [motifTypeahead]="userList$ | async"
    [customTemplate]="customTemplate" (clear)="clearOption($event)" />
  <ng-template #customTemplate let-option="option" let-label="Name">
    <button type="button" class="userDiv" (click)="selectEvent(option)">
      <motif-avatar size="medium"
        [userName]="option.Name == null || option.Name == '' ? 'No Name' : option.Name"></motif-avatar>
      <div class="avatardiv">
        <span class="user-name">{{ option.Name }}</span>
        <span class="sub-email">{{ option.Email }}</span>
      </div>
    </button>
  </ng-template>
  <motif-icon size="20" [iconFunction]="contactIcon" class="right-side"></motif-icon>
</motif-form-field>

<motif-form-field *ngIf="shareUser && !isNonEYUser" class="searchUserField">
  <input #searchInput type="text" *ngIf="!isNonEYUser" motifInput aria-label="User" placeholder="{{ 'AddTeamMembers' | translate }}"
    (keyup)="onInputChange($event)" [motifTypeahead]="userList$ | async" [customTemplate]="customTemplate"
    (clear)="clearOption($event)" />     

  <ng-template #customTemplate let-label="label" let-option="option" let-term="term">
    <button type="button" class="userDiv" (click)="selectEvent(option)">
      <motif-avatar size="medium"
        [userName]="option.Name == null || option.Name == '' ? 'No Name' : option.Name"></motif-avatar>
      <div class="avatardiv">
        <span class="user-name">{{ option.Name }}</span>
        <span class="sub-email">{{ option.Email }}</span>
      </div>
    </button>
  </ng-template>
 
  <app-chip-dropdown [selectedvalue]="selectedRole" (selectedData)="selectUserRoleEvent($event)"
    [isDisabled]="isDisabled" [list]="statusList"></app-chip-dropdown>
</motif-form-field>

<motif-form-field *ngIf="isNonEYUser" class="searchUserField"> 
     <div class="input-wrapper">      
      <input #searchInput type="text" [(ngModel)]="externalUser" motifInput aria-label="User" placeholder="{{ 'CreateTags' | translate }}" />
        <!-- Motif Icon inside the input field -->
      <motif-icon size="25" *ngIf="isNonEYUser" title="{{ 'Save' | translate }}"
        tabindex="0" role="button"
        (click)="isValidInput ? addExternalUser() : null"
        (keydown.enter)="isValidInput ? addExternalUser() : null"
        (keydown.space)="isValidInput ? addExternalUser() : null; $event.preventDefault()"
        class="icon-inside-input" [iconFunction]="saveIcon"
        [attr.aria-disabled]="!isValidInput"
        [ngClass]="{'disabled-icon': !isValidInput}"></motif-icon>
    </div>
</motif-form-field>